module.exports = __webpack_public_path__ + "img/icon_fb.67d5318f.svg";